import { useState } from 'react';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  IconButton,
  Stack,
  Tab,
  Tabs,
  Typography
} from '@mui/material';

import PersonalInfo from './PersonalInfo';
import JobDetail from './JobDetail';
import ContactDetails from './ContactDetails';
import EducationDetails from './EducationDetails';
// import ExtraDetails from './ExtraDetails';
import TrainingExp from './TrainingExp';
import Trainings from './Trainings';
import { ImCross } from 'react-icons/im';
import {
  usePersonalDetailQuery,
  useCurrentUserDetailsQuery
} from 'redux/reducers/user/dashboard/tms-user';
import { BiCamera } from 'react-icons/bi';
import { backendURL } from 'redux/reducers/settings';
import ExtraDetails from './ExtraDetails';
export enum PlaceType {
  'Nepal' = 1,
  'Foreign Country' = 2
}

export interface TraineeProfile {
  first_name: string;
  first_name_np: string;
  last_name: string;
  last_name_np: string;
  middle_name: string;
  middle_name_np: string;
  dob: string;
  mobile_number: string;

  address: {
    province: string;
    district: string;
    municipality: string;
    ward_no: string;
    block_no: string;
    house_num: string;
    tole_street: string;
  };
  ethnicity: string;
  service_group: string;
  previous_training: {
    name: string;
    from_date: string;
    to_date: string;
    place_type: PlaceType;
    place: string;
  }[];

  experience: {
    from_date: string;
    to_date: string;
    organization: string;
    department: string;
    level: string;
    is_first_service: 'True' | 'False';
    is_current_service: 'False' | 'True';
  }[];

  signature: File | null;
  image: File | null;
}

const initialValues: TraineeProfile = {
  first_name: '',
  first_name_np: '',
  middle_name: '',
  middle_name_np: '',
  last_name: '',
  last_name_np: '',
  mobile_number: '',
  dob: '',
  address: {
    province: '',
    district: '',
    municipality: '',
    ward_no: '',
    block_no: '',
    house_num: '',
    tole_street: ''
  },
  previous_training: [],
  experience: [],
  signature: null as File | null,
  image: null as File | null,
  ethnicity: '',
  service_group: ''
};

const TraineeProfile = () => {
  const [activeStep, setActiveStep] = useState<number>(1);

  const [stepCompleted, setStepCompleted] = useState({
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: true,
    7: true
  });

  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', py: 4 }}>
      {/* Added justifyContent="center" to the Grid Container */}
      <Grid container spacing={3} justifyContent="center">
        <Grid item xs={12} sm={12} md={9}>
          {/* overflow visible so a tab's sticky action bar can pin while scrolling */}
          <Card sx={{ boxShadow: 'none', borderRadius: 3, overflow: 'visible' }}>
            <CardContent>
              <Tabs
                value={activeStep - 1}
                onChange={(e, step) => setActiveStep(step + 1)}
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
              >
                <Tab label="Personal Detail" id="personalDetail" aria-controls="personalDetail" />
                <Tab
                  label="Contact Details"
                  id="contact_detail"
                  aria-controls="contact_detail"
                  disabled={!stepCompleted[2]}
                />
                <Tab
                  label="Experience"
                  id="exp_training"
                  aria-controls="exp_training"
                  disabled={!stepCompleted[3]}
                />
                <Tab
                  label="Trainings"
                  id="exp_training"
                  aria-controls="exp_training"
                  disabled={!stepCompleted[4]}
                />

                <Tab
                  label="Education Details"
                  id="education_details"
                  aria-controls="education_details"
                  disabled={!stepCompleted[5]}
                />
                <Tab
                  label="Job Detail"
                  id="job_detail"
                  aria-controls="job_detail"
                  disabled={!stepCompleted[6]}
                />
                <Tab
                  label="Extra Detail"
                  id="extra_detail"
                  aria-controls="extra_detail"
                  disabled={!stepCompleted[7]}
                />
              </Tabs>
            </CardContent>

            <CardContent>
              {activeStep === 1 && (
                <PersonalInfo activeStep={activeStep} setActiveStep={setActiveStep} />
              )}
              {activeStep === 2 && (
                <ContactDetails activeStep={activeStep} setActiveStep={setActiveStep} />
              )}
              {activeStep === 3 && (
                <TrainingExp activeStep={activeStep} setActiveStep={setActiveStep} />
              )}
              {activeStep === 4 && (
                <Trainings activeStep={activeStep} setActiveStep={setActiveStep} />
              )}
              {activeStep === 5 && (
                <EducationDetails activeStep={activeStep} setActiveStep={setActiveStep} />
              )}
              {activeStep === 6 && (
                <JobDetail activeStep={activeStep} setActiveStep={setActiveStep} />
              )}
              {activeStep === 7 && (
                <ExtraDetails activeStep={activeStep} setActiveStep={setActiveStep} />
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TraineeProfile;
